module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Printer.b5bc70c1.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Printer.svg
// module id = 1603
// module chunks = 0